import type { CompanyUser } from '../types/company-admin.types';

export interface UserResponse {
  id: string;
  email: string;
  profile: { firstName: string; lastName: string; fullName: string };
  roles: string[];
  isActive: boolean;
  lastLoginAt?: string;
  createdAt: string;
}

export function mapUserResponse(user: UserResponse): CompanyUser {
  return {
    id: user.id,
    email: user.email,
    firstName: user.profile.firstName,
    lastName: user.profile.lastName,
    fullName: user.profile.fullName,
    roles: user.roles as CompanyUser['roles'],
    isActive: user.isActive,
    lastLoginAt: user.lastLoginAt,
    createdAt: user.createdAt,
  };
}
